module.exports = __webpack_public_path__ + "img/wheelM3.7db96ecf.png";